import { render, staticRenderFns } from "./order-audit.vue?vue&type=template&id=e8a0d7cc&"
import script from "./order-audit.vue?vue&type=script&lang=js&"
export * from "./order-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports